// promoción 2x1/4x3
import { useState } from 'react';

import ProductItem from '../Product/ProductItem';
import ProductSelect from '../Product/ProductSelect';

import { confirmDialog } from '../../../../actions/swal_msg';
import { savePromoToBD } from '../../../../actions/admin/promotion';
import { getProductPromotions } from '../../../../helpers/admin/promotion/promotionHelper';

import {
    Button, Typography, Grid, Stack
} from "@mui/material";
import StarPurple500Icon from '@mui/icons-material/StarPurple500';

import { PROMO_PRODUCT } from '../../../../constants/shop/promotion/promotion_const';

const PromoOne = ({
    today, promotion, allProducts,
    activePromotion, setActivePromotion,
    otherPromotion, setOtherPromotion
}) => {
    const { promo, start_date, end_date } = promotion;
    // producto A seleccionado
    const [productA, setProductA] = useState(PROMO_PRODUCT);
    const { variant_id, title, variant_title } = productA;

    // verificar si producto tiene promoción
    const checkPromos = async () => {
        const ActivePromotions = getProductPromotions(promo, activePromotion, otherPromotion, { productA });
        if (ActivePromotions.status) {
            if (await confirmDialog('¿Registrar la promoción?', ActivePromotions.html, 'Registrar'))
                savePromo();
        } else savePromo();
    };

    // guardar promoción en BD
    const savePromo = async () => {
        const Model = {
            ...promotion,
            variant_a: {
                _id: variant_id,
                title, variant_title
            }
        };
        const req = await savePromoToBD(Model, 'save-promo-one');
        if (req.status) {
            const { _id } = req.resp;
            // promoción activa
            if (start_date <= today && end_date >= today)
                setActivePromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            else // promoción guardada (no activa)
                setOtherPromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            // limpiar campos
            setProductA(PROMO_PRODUCT);
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                    sx={{ mb: 2 }}>
                    <Typography variant="h6">
                        { `Promoción: ${promo}` }
                    </Typography>
                    <StarPurple500Icon />
                </Stack>

                <Grid container spacing={4}>
                    {
                        variant_id !== '' &&
                            <ProductItem
                                product={productA}
                                setProduct={setProductA}
                                alt={'producto-A'}
                                text={'Producto seleccionado'}
                            />
                    }
                </Grid>

                {
                    variant_id !== '' &&
                        <Button sx={{ mt: 1 }}
                            variant="contained"
                            onClick={ checkPromos }>
                            Guardar promoción
                        </Button>
                }

                <ProductSelect
                    text={''}
                    setProduct={setProductA}
                    allProducts={allProducts}
                />
            </Grid>
        </Grid>
    );
};

export default PromoOne;